export default "__VITE_ASSET__d3df8113__"